<template>
  <Visitor>
  <div class="bg-gray-100">
    <main class="">
      <div
        class="bg-gray-100 flex flex-col justify-center py-12 sm:px-6 lg:px-8"
      >
        <div class="sm:mx-auto sm:w-full sm:max-w-md">
          <img
            class="mx-auto h-36 w-auto"
            src="../../assets/logo_circulo.png"
            alt="Workflow"
          />
          <h2
            class="mt-6 text-center text-3xl leading-9 font-extrabold text-gray-900"
          >
            Ingresa a tu cuenta
          </h2>
        </div>

        <div class="mt-6 sm:mx-auto sm:w-full sm:max-w-md">
          <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <div>
              <label
                for="email"
                class="block text-sm font-medium leading-5 text-gray-700"
              >
                Correo
              </label>
              <div class="mt-1 rounded-md shadow-sm">
                <input
                  v-model="email"
                  id="email"
                  type="email"
                  required
                  class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>
              <small v-if="error_email" class="text-red-600">{{
                error_email
              }}</small>
            </div>

            <div class="mt-4">
              <label
                for="password"
                class="block text-sm font-medium leading-5 text-gray-700"
              >
                Contraseña
              </label>
              <div class="mt-1 rounded-md shadow-sm">
                <input
                  v-model="password"
                  id="password"
                  type="password"
                  required
                  class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                />
              </div>
              <small v-if="error_password" class="text-red-600">{{
                error_password
              }}</small>
            </div>

            <div class="mt-6 flex items-center justify-between">
              <div class="text-sm leading-5">
                <router-link
                  to="#"
                  class="font-medium text-primary-600 hover:text-primary-500 focus:outline-none focus:underline transition ease-in-out duration-150"
                >
                  ¿Olvidaste tu contraseña?
                </router-link>
              </div>
            </div>

            <div class="mt-6">
              <AnimatedButton
                content="Ingresar"
                color="primary"
                @onClick="submitLogin()"
                :isLoading="buttonLoading"
              ></AnimatedButton>
            </div>

            <div class="mt-6 flex text-right justify-between">
              <div class="text-base leading-5">
                <span class="font-medium">¿No tienes una cuenta? </span>
                <router-link
                  to="/signup/indie"
                  class="font-medium text-primary-600 hover:text-primary-500 focus:outline-none focus:underline transition ease-in-out duration-150"
                >
                  ¡Regístrate!
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
  </Visitor>
</template>

<script>
//import api from "../../api";

import Visitor from "../Layouts/Visitor";
import AnimatedButton from "../../components/AnimatedButton.vue";

export default {
  name: "Login",
  components: {
    Visitor,
    AnimatedButton
  },
  data: function() {
    return {
      hasError: false,
      buttonLoading: false,

      email: "",
      password: "",

      error_email: "",
      error_password: ""
    };
  },
  methods: {
    async submitLogin() {
      this.validateSubmit();
      if (this.hasError) return;
      this.buttonLoading = true;
      // Simulación de backend
      
      setTimeout(() => {
        this.$toast.open({
          message: "Inicio de sesión correcto",
          type: "success",
          duration: 8000,
          dismissible: true
        });
        localStorage.setItem('jwt_token', 'prueba')
        localStorage.setItem('user_id', 'user id')
        localStorage.setItem('user_name', 'Nombre Usuario')
        localStorage.setItem('user_level', 'worker')
        this.$router.push("/worker");
      }, 2000);
      
      // Conexión al backend
      /*
      let response = await api.post(`/login`, {
        email: this.email,
        password: this.password
      })
      if (!response.ok) {
        this.buttonLoading = false;
        return this.$toast.open({
          message: response.error || 'Ocurrió un error, vuelva a intentarlo',
          type: "error",
          duration: 8000,
          dismissible: true
        });
      }
      this.$toast.open({
        message: 'Inicio de sesión correcto',
        type: "success",
        duration: 8000,
        dismissible: true
      });
      localStorage.setItem('jwt_token', response.data.jwt_token)
      localStorage.setItem('user_id', response.data.user_id)
      localStorage.setItem('user_name', response.data.user_name)
      // user_level: worker (Trabajador), customer (Cliente)
      localStorage.setItem('user_level', response.data.user_level)
      this.$router.push("/worker");*/
    },
    validateSubmit() {
      this.hasError = false;
      if (this.email == "") {
        this.hasError = true;
        this.error_email = "Campo obligatorio";
      } else if (!this.email.includes('@') || !this.email.includes('.') || this.email.length < 5) {
        this.hasError = true;
        this.error_email = "Usuario no válido";
      } else this.error_email = "";
      if (this.password == "") {
        this.hasError = true;
        this.error_password = "Campo obligatorio";
      } else this.error_password = "";
    }
  }
};
</script>